<template>
    <div>
        <hero></hero>
        <!-- <basic-elements></basic-elements> -->
        <!-- <inputs></inputs> -->
        <!-- <custom-controls></custom-controls> -->
        <!-- <navigation></navigation> -->
        <javascript-components></javascript-components>
        <icons></icons>
        <examples></examples>
        <download-section></download-section>
        <carousel></carousel>
        <typography></typography>
            <!-- Images -->
            <h2 class="mt-lg mb-5" style="text-align: center;">
                <span>Ý kiến khách hàng</span>
            </h2>
            <images></images>
        <!-- <title-slider></title-slider> -->
    </div>
</template>
<script>
import Hero from "./components/Hero";
// import BasicElements from "./components/BasicElements";
import Inputs from "./components/Inputs";
// import CustomControls from "./components/CustomControls";
import Navigation from "./components/Navigation";
import JavascriptComponents from "./components/JavascriptComponents";
import Carousel from "./components/Carousel";
import Icons from "./components/Icons";
import Examples from "./components/Examples";
import DownloadSection from "./components/DownloadSection";
import Images from "./components/JavascriptComponents/Images";
// import TitleSlider from "./components/TitleSlider";

export default {
  name: "components",
  components: {
    Hero,
    // BasicElements,
    Inputs,
    // CustomControls,
    Navigation,
    JavascriptComponents,
    Carousel,
    Icons,
    Examples,
    DownloadSection,
    Images,
    // TitleSlider
  }
};
</script>
